import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { AdvertisingStore } from 'stores/advertising-store';

import MesoUtils from 'utils/meso';

import { MesoInit } from './internals/meso-init';
import { MesoTargeting } from './internals/meso-targeting';

interface MesoScriptsProps {
  advertising?: AdvertisingStore;
}

@inject('advertising')
@observer
export class MesoScripts extends React.Component<MesoScriptsProps> {
  public componentWillUnmount() {
    MesoUtils.initializeClear();
  }

  public render() {
    const { advertising } = this.props;
    if (advertising && advertising.triggeredPageName) {
      return (
        <AbacusExperiment name="PWA_large_screens_Ads">
          <AbacusControl />
          <AbacusVariant bucket={1}>
            <ErrorBoundary label={'meso.scripts.errorboundary'}>
              <AbacusExperiment name="MeSo_PWA_Lazy_Load">
                <AbacusControl />
                <AbacusVariant bucket={1} />
                <AbacusVariant bucket={2} />
                <AbacusVariant bucket={3} />
                <AbacusVariant bucket={4} />
                <AbacusVariant bucket={5} />
              </AbacusExperiment>
              <AbacusExperiment name="MeSo_GPT_SRA">
                <AbacusControl />
                <AbacusVariant bucket={1} />
              </AbacusExperiment>
              <MesoInit />
              <MesoTargeting />
            </ErrorBoundary>
          </AbacusVariant>
        </AbacusExperiment>
      );
    }

    return null;
  }
}
